import React from 'react';
import Chip from '@mui/material/Chip';
const classes = {
    chip: {
        marginRight: '8px',
        marginBottom: '8px',
        backgroundColor: '#f5f5f5',
    },
    chipContainer: {
        padding: '12px',
        minHeight: '40px',
    },
};
export const ChipsBar = ({ searchQuery, removeFacetField, }) => {
    return (React.createElement("div", { style: classes.chipContainer }, searchQuery.selectedItems.map((item) => {
        return item.facetId === 'project' ? (React.createElement("div", { key: `${item.facetId}-${item.fieldId}`, style: classes.chip })) : (React.createElement(Chip, { sx: classes.chip, key: `${item.facetId}-${item.fieldId}`, label: `${item.facetId}:${item.fieldId}`, onDelete: () => {
                removeFacetField(item.facetId, item.fieldId);
            }, variant: 'outlined', color: 'primary' }));
    })));
};
